import { render, staticRenderFns } from "./RepairRequest.vue?vue&type=template&id=4521474e&scoped=true&"
import script from "./RepairRequest.vue?vue&type=script&lang=ts&"
export * from "./RepairRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521474e",
  null
  
)

export default component.exports